import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BuddyLogo } from "../components/Brand";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { Button } from "../components/ui/button";
import { Ear, Eye, Zap, Hand, Volume2, Circle } from "lucide-react";

export default function AccessibilityInfo() {
  const { t } = useTranslation();
  const ITEMS = [
    { icon: Volume2, key: "voice_first" },
    { icon: Circle,  key: "braille" },
    { icon: Eye,     key: "low_vision" },
    { icon: Zap,     key: "dyslexia" },
    { icon: Ear,     key: "hearing_support" },
    { icon: Hand,    key: "motor_support" },
  ];
  return (
    <div className="min-h-screen student-bg">
      <header className="hb-glass sticky top-0 z-30">
        <div className="max-w-[1100px] mx-auto px-6 py-3 flex items-center justify-between">
          <Link to="/"><BuddyLogo /></Link>
          <div className="flex gap-2 items-center">
            <LanguageSwitcher />
            <Link to="/pricing"><Button variant="ghost">{t("nav.pricing")}</Button></Link>
            <Link to="/register"><Button className="bg-slate-900 hover:bg-slate-800 text-white">{t("common.getStarted")}</Button></Link>
          </div>
        </div>
      </header>
      <main className="max-w-[1100px] mx-auto px-6 py-10">
        <h1 className="font-student font-bold text-4xl sm:text-5xl text-slate-900">{t("landing.builtForLearners")}</h1>
        <p className="text-slate-700 max-w-2xl mt-2">{t("landing.builtForBody")}</p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
          {ITEMS.map((it) => (
            <div className="hb-card p-6" key={it.key}>
              <div className="w-10 h-10 rounded-lg bg-blue-600 text-white flex items-center justify-center mb-3"><it.icon className="w-5 h-5"/></div>
              <div className="font-adult font-bold text-slate-900">{t(`access.${it.key}`)}</div>
            </div>
          ))}
        </div>
        <div className="mt-10 rounded-3xl bg-blue-600 text-white p-8">
          <h2 className="font-adult font-bold text-2xl">{t("common.getStarted")}</h2>
          <p className="text-blue-100 mt-1">{t("access.setupSubtitle")}</p>
          <div className="mt-3 flex gap-2 flex-wrap">
            <Link to="/register"><Button className="bg-white text-blue-700 hover:bg-blue-50 rounded-full">{t("common.createAccount")}</Button></Link>
            <Link to="/login"><Button variant="outline" className="border-white text-white hover:bg-white/10 rounded-full">{t("common.signIn")}</Button></Link>
          </div>
        </div>
      </main>
    </div>
  );
}
